import React from "react";
import CFileUpload from "common/Form/CFileUpload";
import CDate from "common/Form/CDate";

function CFormSchemaBuilder(tableSchema) {
  let uiSchema = {};
  uiSchema["ui:autofocus"] = true;
  if (tableSchema.properties !== undefined) {
    uiSchema["ui:layout_grid"] = buildSchema(
      Object.keys(tableSchema.properties)
    );
    uiSchema["ui:field"] = "layout_grid";
  }
  return Object(uiSchema);
}
function buildSchema(tableFieldList) {
  const fieldCount = tableFieldList.length;
  const rowSplitFieldSize = 1;
  let rowSize = "12";
  if (fieldCount > rowSplitFieldSize) {
    rowSize = "6";
  }
  var childObject = [];
  var rowObject = [];
  for (var i = 0; i < fieldCount; i++) {
    if (fieldCount > rowSplitFieldSize) {
      if (i % 2 === 0) {
        rowObject = [];
      }
    }
    rowObject.push(buildColSchema(rowSize, tableFieldList[i]));
    if (fieldCount > rowSplitFieldSize) {
      if (i % 2 === 1) {
        childObject.push(buildRowScehma(rowObject));
        rowObject = [];
      }
    }
  }
  if (rowObject) {
    childObject.push(buildRowScehma(rowObject));
  }
  return buildRowScehma(buildColSchema("12", childObject));
}
function buildRowScehma(rowSchema) {
  return {
    "ui:row": Array.isArray(rowSchema) ? rowSchema : [rowSchema],
  };
}
function buildColSchema(size, fieldObj) {
  return {
    "ui:col": {
      md: size,
      children: Array.isArray(fieldObj) ? fieldObj : [fieldObj],
    },
  };
}

const CFileWidgets = function (props) {
  return <CFileUpload {...props} />;
};
const CMonthRangeWidget = function (props) {
  return <input className="form-control" type="month" id={props.id} />;
};
const CDateWidgets = function (props) {
  return <CDate {...props} />;
};
export const customWidgets = {
  FileWidget: CFileWidgets,
  monthRange: CMonthRangeWidget,
  DateWidget: CDateWidgets,
};

export default CFormSchemaBuilder;
